export const TAX_AND_FINANCIAL_REQUEST = "TAX_AND_FINANCIAL_REQUEST";
export const TAX_AND_FINANCIAL_SUCCESS = "TAX_AND_FINANCIAL_SUCCESS";
export const TAX_AND_FINANCIAL_FAIL = "TAX_AND_FINANCIAL_FAIL";
